/* eslint-disable react/jsx-key */
import $ from 'jquery';
import React, { Component, lazy } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import Progress from './theme/progress';
import Navigation from './theme/navigation';
import TopHeader from './theme/topHeader';
import Footer from './theme/footer';
import { correctHeight, detectBody } from './theme/helpers/helpers';
import WaitingComponent from './theme/waiting';
import { withContext } from './helpers/context';
import { isMobile } from 'react-device-detect';
import config from './config';
//import axios from "axios";
import axios from 'helpers/axioshelper';
import list from './constants/list';
import { USER_FROM_USER } from './constants/constants';
import NotFound from './components/common/notFound';
import componentLoader from './theme/componentLoader';

const Dashboard = lazy(() => componentLoader(() => import('./components/pages/dashboard')));
const Inbox = lazy(() => componentLoader(() => import('./components/pages/inbox')));
const Compose = lazy(() => componentLoader(() => import('./components/pages/compose')));
const Contacts = lazy(() => componentLoader(() => import('./components/pages/contacts')));
const Home = lazy(() => componentLoader(() => import('./components/pages/home')));
const Profile = lazy(() => componentLoader(() => import('./components/pages/profile')));
const Permissions = lazy(() => componentLoader(() => import('./components/pages/permissions')));

const DatabaseInventory = lazy(() =>
  componentLoader(() => import('./components/pages/database/inventory/main'))
);
const DatabaseInventoryNew = lazy(() =>
  componentLoader(() => import('./components/pages/database/inventory/new/main'))
);
const DatabaseInventoryNewCompetitor = lazy(() =>
  componentLoader(() => import('./components/pages/database/inventory/competitor/main'))
);
const DatabaseInventoryNewEvaluation = lazy(() =>
  componentLoader(() => import('./components/pages/database/inventory/evaluation/detail'))
);
const DatabaseInventoryListEvaluation = lazy(() =>
  componentLoader(() => import('./components/pages/database/inventory/evaluation/main'))
);
const DatabaseInventoryDetail = lazy(() =>
  componentLoader(() => import('./components/pages/database/inventory/detail'))
);
const DatabaseInventoryEvaluationPDF = lazy(() =>
  componentLoader(() => import('./components/pages/database/inventory/evaluation/exportPDF'))
);

const MasterdataMain = lazy(() =>
  componentLoader(() => import('./components/pages/masterdata/main'))
);
const MasterdataBrandsDetail = lazy(() =>
  componentLoader(() => import('./components/pages/masterdata/brands/main'))
);
const MasterdataVisualTheme = lazy(() =>
  componentLoader(() => import('./components/pages/masterdata/visualtheme/main'))
);

const SettingsMain = lazy(() => componentLoader(() => import('./components/pages/settings/main')));
const SettingsLog = lazy(() =>
  componentLoader(() => import('./components/pages/settings/log/main'))
);
const SettingsConfiguration = lazy(() =>
  componentLoader(() => import('./components/pages/settings/configuration/main'))
);
const SettingsConfigurationMaintenance = lazy(() =>
  componentLoader(() => import('./components/pages/settings/configuration/maintenance'))
);
const SettingsEvaluationFormula = lazy(() =>
  componentLoader(() => import('./components/pages/settings/evaluationformula/main'))
);

const VisualPlan = lazy(() => componentLoader(() => import('./components/pages/visualplan/main')));

const VisualPlanNew = lazy(() =>
  componentLoader(() => import('./components/pages/visualplan/detail'))
);

const VisualPlanDrafts = lazy(() =>
  componentLoader(() => import('./components/pages/visualplan/drafts'))
);
const VisualPlanEdit = lazy(() =>
  componentLoader(() => import('./components/pages/visualplan/edit'))
);
const VisualPlanDetail = lazy(() =>
  componentLoader(() => import('./components/pages/visualplan/detail'))
);
const OrderCover = lazy(() => componentLoader(() => import('./components/pages/ordercover/main')));
const OrderCoverDetail = lazy(() =>
  componentLoader(() => import('./components/pages/ordercover/detail'))
);

const FeaturesNotificationMain = lazy(() =>
  componentLoader(() => import('./components/pages/features/notification/main'))
);

const OohVendorSelection = lazy(() =>
  componentLoader(() => import('./components/pages/report/oohvendor/ooh_vendor_selection'))
);
const VendorPerformance = lazy(() =>
  componentLoader(() => import('./components/pages/report/oohvendor/performance/main'))
);
const VendorPerformanceDetail = lazy(() =>
  componentLoader(() => import('./components/pages/report/oohvendor/performance/detail'))
);
const VendorMonitoring = lazy(() =>
  componentLoader(() => import('./components/pages/report/oohvendor/monitoring/main'))
);
const VendorMonitoringDetail = lazy(() =>
  componentLoader(() => import('./components/pages/report/oohvendor/monitoring/detail'))
);
const VendorComplaint = lazy(() =>
  componentLoader(() => import('./components/pages/report/oohvendor/complaint/main'))
);
const VendorComplaintDetail = lazy(() =>
  componentLoader(() => import('./components/pages/report/oohvendor/complaint/detail'))
);
const OohReportInventory = lazy(() =>
  componentLoader(() => import('./components/pages/report/ooh/inventory'))
);
const OohReportVisualPlan = lazy(() =>
  componentLoader(() => import('./components/pages/report/ooh/visualplan'))
);
const OohReportMonitoring = lazy(() =>
  componentLoader(() => import('./components/pages/report/ooh/monitoring'))
);

const LamphopReportSelection = lazy(() =>
  componentLoader(() => import('./components/pages/report/lamphop/report_lamphop_selection'))
);
const LamphopReportKpi = lazy(() =>
  componentLoader(() => import('./components/pages/report/lamphop/lamphop_kpi'))
);
const LamphopReportBrandingMaterial = lazy(() =>
  componentLoader(() => import('./components/pages/report/lamphop/lamphop_branding_material'))
);
const DstReportMain = lazy(() =>
  componentLoader(() => import('./components/pages/report/dst/main'))
);
const CommunityReportMain = lazy(() =>
  componentLoader(() => import('./components/pages/report/community/main'))
);

const VendorAccessMonitoring = lazy(() =>
  componentLoader(() => import('./components/vendoraccess/monitoring/main'))
);
const VendorAccessMonitoringDetail = lazy(() =>
  componentLoader(() => import('./components/vendoraccess/monitoring/detail'))
);
const VendorAccessComplaint = lazy(() =>
  componentLoader(() => import('./components/vendoraccess/complaint/main'))
);
const VendorAccessComplaintDetail = lazy(() =>
  componentLoader(() => import('./components/vendoraccess/complaint/detail'))
);

const VendorAccessMonitoringResponsive = lazy(() =>
  componentLoader(() => import('./components/vendoraccess/responsivemonitoring/main'))
);
const VendorAccessMonitoringDetailResponsive = lazy(() =>
  componentLoader(() => import('./components/vendoraccess/responsivemonitoring/detail'))
);
const VendorAccessComplaintResponsive = lazy(() =>
  componentLoader(() => import('./components/vendoraccess/responsivecomplaint/main'))
);
const VendorAccessComplaintDetailResponsive = lazy(() =>
  componentLoader(() => import('./components/vendoraccess/responsivecomplaint/detail'))
);

const MasterdataCpaWo = lazy(() =>
  componentLoader(() => import('./components/pages/masterdata/cpa/wo'))
);
const MasterdataCpaArea = lazy(() =>
  componentLoader(() => import('./components/pages/masterdata/cpa/area'))
);
const MasterdataCpaBrand = lazy(() =>
  componentLoader(() => import('./components/pages/masterdata/cpa/brand'))
);
const MasterdataCpaKpi = lazy(() =>
  componentLoader(() => import('./components/pages/masterdata/cpa/kpi'))
);

const MasterdataInventoryAllocation = lazy(() =>
  componentLoader(() => import('./components/pages/masterdata/inventoryallocation/main'))
);
const MasterdataInventoryAllocationDetail = lazy(() =>
  componentLoader(() => import('./components/pages/masterdata/inventoryallocation/detail'))
);

const MasterdataVendor = lazy(() =>
  componentLoader(() => import('./components/pages/masterdata/vendor/main'))
);

const MasterdataCompany = lazy(() =>
  componentLoader(() => import('./components/pages/masterdata/company/main'))
);

const MasterdataType = lazy(() =>
  componentLoader(() => import('./components/pages/masterdata/typeSizeCombination/type'))
);
const MasterdataSize = lazy(() =>
  componentLoader(() => import('./components/pages/masterdata/typeSizeCombination/size'))
);
const MasterdataTypeCmb = lazy(() =>
  componentLoader(() => import('./components/pages/masterdata/typeSizeCombination/typeCmb'))
);

const SettingListofValue = lazy(() =>
  componentLoader(() => import('./components/pages/settings/listOfValue/main'))
);

class AppRoutes extends Component {
  state = {
    match: false,

    navigationMenuIds: [], //array of int
    navigationMenu: [],
    isNavigationMenuDone: false,

    masterMenuIds: [], //array of int
    masterDataMenu: [],
    isMasterMenuDone: false,

    settingsMenuIds: [], //array of int
    settingsDataMenu: [],
    isSettingsMenuDone: false
  };

  constructor(props) {
    super(props);

    this.setState({
      match: props.match
    });

    this.fetchNavigationMenu();
    if (this.props.UserFrom === USER_FROM_USER) {
      this.fetchMasterDataMenu();
      this.fetchSettingsMenu();
    }
  }

  componentDidMount() {
    // eslint-disable-next-line func-names
    $(window).bind('load resize', function () {
      correctHeight();
      detectBody();
    });

    // console.log("urlnya", this.state.match.url)
  }

  fetchNavigationMenu() {
    const navigationMenu = this.props.UserFrom === USER_FROM_USER ? [] : list.menu_vendor;
    //console.log('UserFrom',this.props.UserFrom);
    console.log(window.context.access_token);
    if (this.props.UserFrom === USER_FROM_USER) {
      axios({
        method: 'get',
        url: `${config.urlEndPointModistShared}api/Menu/${window.context.UserRole}/User`,
        responseType: 'json',
        headers: {
          Authorization: `token ${window.context.access_token}`
        }
      }).then((response) => {
        // console.log('get menu', response.data);

        const openedMenuIds = response?.data.reduce((acc, datum) => {
          // bikin datum.id dan submenus.id jadi 1 array
          const ids = [datum.id].concat(datum.subMenu.map((sub) => sub.id));
          return [...acc, ...ids];
        }, []);

        // console.log('openedMenuIds', openedMenuIds);

        const navigationMenu = list.menu_user.reduce((acc, option) => {
          if (openedMenuIds?.some((openedMenuId) => parseInt(option.id) === openedMenuId)) {
            acc.push(option);
          }
          return acc;
        }, []);

        // console.log('navigationMenu', navigationMenu);

        this.setState({
          navigationMenuIds: openedMenuIds ?? [],
          navigationMenu,
          isNavigationMenuDone: true
        });
      });
    } else {
      // const navigationMenu = list.menu_vendor.reduce(
      //     (acc, option) => {
      //         acc.push(option);
      //         return acc;
      //     },
      //     []
      // );

      // console.log('a1231 navigationMenu' ,navigationMenu);

      this.setState({ navigationMenu, isNavigationMenuDone: true });
    }
  }

  fetchMasterDataMenu() {
    axios({
      method: 'get',
      url: `${config.urlEndPointModistShared}api/Menu/Level3/1000/${window.context.UserRole}/User`,
      responseType: 'json'
    }).then((response) => {
      // console.log('get 1000', response.data);

      const openedMenuIds = response?.data.reduce((acc, datum) => {
        return [...acc, datum.id];
      }, []);

      const masterDataMenu = response?.data.map((datum) => ({
        id: datum.id,
        className: datum.icon,
        title: datum.menuName.replace('<br>', '\n'),
        link: datum.url.replace(config.urlInternalFrontend, '/')
      }));

      //console.log('masterDataMenu', masterDataMenu);

      this.setState({ masterMenuIds: openedMenuIds, masterDataMenu, isMasterMenuDone: true });
    });
  }

  fetchSettingsMenu() {
    axios({
      method: 'get',
      url: `${config.urlEndPointModistShared}api/Menu/Level3/2000/${window.context.UserRole}/User`,
      responseType: 'json'
    }).then((response) => {
      // console.log('get 2000', response.data);

      const openedMenuIds = response?.data.reduce((acc, datum) => {
        return [...acc, datum.id];
      }, []);

      const settingsDataMenu = response?.data.map((datum) => ({
        id: datum.id,
        className: datum.icon,
        title: datum.menuName.replace('<br>', '\n'),
        link: datum.url.replace(config.urlInternalFrontend, '/')
      }));

      this.setState({ settingsMenuIds: openedMenuIds, settingsDataMenu, isSettingsMenuDone: true });
    });
  }

  render() {
    const {
      navigationMenuIds,
      masterMenuIds,
      settingsMenuIds,
      isNavigationMenuDone
      // isMasterMenuDone,
      // isSettingsMenuDone
    } = this.state;

    const isReadyToRender = isNavigationMenuDone; //&& isMasterMenuDone && isSettingsMenuDone;

    if (!isReadyToRender && this.props.UserFrom === USER_FROM_USER) {
      return <h1>Please Wait...</h1>;
    }

    const useResponsivePageName = isMobile ? 'responsive' : '';

    const navigationMenuVendor = list.menu_vendor.reduce((acc, option) => {
      acc.push(option);
      return acc;
    }, []);

    window.context.masterDataMenu = this.state.masterDataMenu;
    window.context.settingsDataMenu = this.state.settingsDataMenu;

    // console.log('this.state.navigationMenuIds', navigationMenuIds, navigationMenuIds.includes(12) );

    const isHaveMasterDataAccess = navigationMenuIds.includes(20);
    const isHaveSettingsAccess = navigationMenuIds.includes(21);

    return (
      <div id="wrapper" className="app">
        <Progress />
        <Navigation
          listMenu={
            this.props.UserFrom === USER_FROM_USER
              ? this.state.navigationMenu
              : navigationMenuVendor
          }
        />
        <div id="page-wrapper" className="gray-bg">
          <TopHeader />
          {this.props.UserFrom === USER_FROM_USER ? (
            <Switch>
              {/*<Route path={`${this.state.match.url}`} exact component={Dashboard} />*/}
              <Route path="/" exact component={WaitingComponent(DatabaseInventory)} />
              {navigationMenuIds.includes(12) && [
                // TODO: fix key map
                <Route
                  path="/database/inventory"
                  exact
                  component={WaitingComponent(DatabaseInventory)}
                />,
                <Route
                  path="/database/inventory/new"
                  exact
                  component={WaitingComponent(DatabaseInventoryNew)}
                />,
                <Route
                  path="/database/inventory/new/competitor"
                  exact
                  component={WaitingComponent(DatabaseInventoryNewCompetitor)}
                />,
                <Route
                  path="/database/inventory/evaluation/detail"
                  exact
                  component={WaitingComponent(DatabaseInventoryNewEvaluation)}
                />,
                <Route
                  path="/database/inventory/evaluation"
                  exact
                  component={WaitingComponent(DatabaseInventoryListEvaluation)}
                />,
                <Route
                  path="/database/inventory/Detail"
                  exact
                  component={WaitingComponent(DatabaseInventoryDetail)}
                />,
                <Route
                  path="/database/inventory/evaluation/pdf"
                  exact
                  component={WaitingComponent(DatabaseInventoryEvaluationPDF)}
                />
              ]}

              {navigationMenuIds.includes(14) && [
                <Route path="/visualplan" exact component={WaitingComponent(VisualPlan)} />,
                <Route path="/visualplan/new" exact component={WaitingComponent(VisualPlanNew)} />,
                <Route
                  path="/visualplan/drafts"
                  exact
                  component={WaitingComponent(VisualPlanDrafts)}
                />,
                <Route
                  path="/visualplan/edit"
                  exact
                  component={WaitingComponent(VisualPlanEdit)}
                />,
                <Route
                  path="/visualplan/detail"
                  exact
                  component={WaitingComponent(VisualPlanDetail)}
                />,
                <Route path="/ordercover" exact component={WaitingComponent(OrderCover)} />,
                <Route
                  path="/ordercover/detail"
                  exact
                  component={WaitingComponent(OrderCoverDetail)}
                />
              ]}
              {isHaveMasterDataAccess && (
                <Route path="/masterdata" exact component={WaitingComponent(MasterdataMain)} />
              )}
              {isHaveSettingsAccess && (
                <Route path="/settings" exact component={WaitingComponent(SettingsMain)} />
              )}
              {isHaveMasterDataAccess &&
                masterMenuIds.includes(36) && [
                  <Route
                    path="/administration/masterdata/brands"
                    exact
                    component={WaitingComponent(MasterdataBrandsDetail)}
                  />
                ]}
              {isHaveMasterDataAccess &&
                masterMenuIds.includes(37) && [
                  <Route
                    path="/administration/masterdata/visualtheme"
                    exact
                    component={WaitingComponent(MasterdataVisualTheme)}
                  />
                ]}
              {isHaveMasterDataAccess &&
                masterMenuIds.includes(39) && [
                  <Route
                    path="/administration/masterdata/type"
                    exact
                    component={WaitingComponent(MasterdataType)}
                  />,
                  <Route
                    path="/administration/masterdata/size"
                    exact
                    component={WaitingComponent(MasterdataSize)}
                  />,
                  <Route
                    path="/administration/masterdata/typecmb"
                    exact
                    component={WaitingComponent(MasterdataTypeCmb)}
                  />
                ]}
              {isHaveMasterDataAccess &&
                masterMenuIds.includes(43) && [
                  <Route
                    path="/administration/masterdata/inventoryallocation"
                    exact
                    component={WaitingComponent(MasterdataInventoryAllocation)}
                  />,
                  <Route
                    path="/administration/masterdata/inventoryallocation/detail"
                    exact
                    component={WaitingComponent(MasterdataInventoryAllocationDetail)}
                  />
                ]}
              {isHaveMasterDataAccess &&
                masterMenuIds.includes(34) && [
                  <Route
                    path="/administration/masterdata/vendor"
                    exact
                    component={WaitingComponent(MasterdataVendor)}
                  />
                ]}
              {isHaveMasterDataAccess &&
                masterMenuIds.includes(35) && [
                  <Route
                    path="/administration/masterdata/company"
                    exact
                    component={WaitingComponent(MasterdataCompany)}
                  />
                ]}
              {isHaveMasterDataAccess &&
                masterMenuIds.includes(40) && [
                  <Route
                    path="/administration/masterdata/cpa"
                    exact
                    component={WaitingComponent(MasterdataCpaWo)}
                  />,
                  <Route
                    path="/administration/masterdata/cpa/area"
                    exact
                    component={WaitingComponent(MasterdataCpaArea)}
                  />,
                  <Route
                    path="/administration/masterdata/cpa/kpi"
                    exact
                    component={WaitingComponent(MasterdataCpaKpi)}
                  />,
                  <Route
                    path="/administration/masterdata/cpa/brand"
                    exact
                    component={WaitingComponent(MasterdataCpaBrand)}
                  />
                ]}
              {isHaveSettingsAccess &&
                settingsMenuIds.includes(101) && [
                  <Route
                    path="/administration/settings/configuration"
                    exact
                    component={WaitingComponent(SettingsConfiguration)}
                  />,
                  <Route
                    path="/administration/settings/configuration/maintenance"
                    exact
                    component={WaitingComponent(SettingsConfigurationMaintenance)}
                  />
                ]}
              {isHaveSettingsAccess &&
                settingsMenuIds.includes(100) && [
                  <Route
                    path="/administration/settings/evalformula"
                    exact
                    component={WaitingComponent(SettingsEvaluationFormula)}
                  />
                ]}
              {isHaveSettingsAccess &&
                settingsMenuIds.includes(102) && [
                  <Route
                    path="/administration/settings/log"
                    exact
                    component={WaitingComponent(SettingsLog)}
                  />
                ]}
              {isHaveSettingsAccess &&
                settingsMenuIds.includes(104) && [
                  <Route
                    path="/administration/settings/lov"
                    exact
                    component={WaitingComponent(SettingListofValue)}
                  />
                ]}
              <Route
                path="/features/notification"
                exact
                component={WaitingComponent(FeaturesNotificationMain)}
              />
              <Route
                path={`${this.state.match.url}/inbox`}
                exact
                component={WaitingComponent(Inbox)}
              />
              <Route
                path={`${this.state.match.url}/compose`}
                exact
                component={WaitingComponent(Compose)}
              />
              <Route path="/contacts" exact component={WaitingComponent(Contacts)} />
              <Route
                path={`${this.state.match.url}/profile`}
                exact
                component={WaitingComponent(Profile)}
              />
              <Route
                path={`${this.state.match.url}/dashboard`}
                exact
                component={WaitingComponent(Dashboard)}
              />
              <Route path="/home" exact component={WaitingComponent(Home)} />
              <Route
                path={`${this.state.match.url}/permissions`}
                exact
                component={WaitingComponent(Permissions)}
              />
              {/* Reporting */}
              {navigationMenuIds.includes(17) && [
                <Route
                  path="/report/oohvendor"
                  exact
                  component={WaitingComponent(OohVendorSelection)}
                />,
                <Route
                  path="/report/oohvendor/performance"
                  exact
                  component={WaitingComponent(VendorPerformance)}
                />,
                <Route
                  path="/report/oohvendor/performance/detail"
                  exact
                  component={WaitingComponent(VendorPerformanceDetail)}
                />,
                <Route
                  path="/report/oohvendor/monitoring"
                  exact
                  component={WaitingComponent(VendorMonitoring)}
                />,
                <Route
                  path="/report/oohvendor/monitoring/detail"
                  exact
                  component={WaitingComponent(VendorMonitoringDetail)}
                />,
                <Route
                  path="/report/oohvendor/complaint"
                  exact
                  component={WaitingComponent(VendorComplaint)}
                />,
                <Route
                  path="/report/oohvendor/complaint/detail"
                  exact
                  component={WaitingComponent(VendorComplaintDetail)}
                />,
                <Route
                  path="/report/ooh/inventory"
                  exact
                  component={WaitingComponent(OohReportInventory)}
                />,
                <Route
                  path="/report/ooh/visualplan"
                  exact
                  component={WaitingComponent(OohReportVisualPlan)}
                />,
                <Route
                  path="/report/ooh/monitoring"
                  exact
                  component={WaitingComponent(OohReportMonitoring)}
                />
              ]}
              {/* Report KPI */}
              {navigationMenuIds.includes(206) && [
                <Route
                  path="/report/lamphop"
                  exact
                  component={WaitingComponent(LamphopReportSelection)}
                />,
                <Route
                  path="/report/lamphop/kpi"
                  exact
                  component={WaitingComponent(LamphopReportKpi)}
                />,
                <Route
                  path="/report/lamphop/branding"
                  exact
                  component={WaitingComponent(LamphopReportBrandingMaterial)}
                />
              ]}
              {/* Report DST */}
              {navigationMenuIds.includes(207) && [
                <Route path="/report/dst" exact component={WaitingComponent(DstReportMain)} />
              ]}
              {/* Report Comunity */}
              {navigationMenuIds.includes(208) && [
                <Route
                  path="/report/community"
                  exact
                  component={WaitingComponent(CommunityReportMain)}
                />
              ]}
              {/* External Links */}
              <Route
                path="/external/dashboard"
                component={() => {
                  window.location.href = config.urlExternalFrontend;
                  return null;
                }}
              />
              <Route
                path="/external/touchpoint"
                component={() => {
                  window.location.href = config.urlExternalFrontend + 'TouchPoint';
                  return null;
                }}
              />
              <Route
                path="/external/branding"
                component={() => {
                  window.location.href = config.urlExternalFrontend + 'branding';
                  return null;
                }}
              />
              <Route
                path="/external/community"
                component={() => {
                  window.location.href = config.urlExternalFrontend + 'ChooseCommunity';
                  return null;
                }}
              />
              <Route
                path="/external/program"
                component={() => {
                  window.location.href = config.urlExternalFrontend + 'programlist';
                  return null;
                }}
              />
              <Route
                path="/external/reportprogram"
                component={() => {
                  window.location.href = config.urlExternalFrontend + 'ProgramReportList';
                  return null;
                }}
              />
              <Route
                path="/external/surveyconsumer"
                component={() => {
                  window.location.href = config.urlExternalSurvey;
                  return null;
                }}
              />
              <Route
                path="/external/dst"
                component={() => {
                  window.location.href = config.urlExternalFrontend + 'DST';
                  return null;
                }}
              />
              <Route
                path="/external/admincommunity"
                component={() => {
                  window.location.href = config.urlExternalFrontend + 'Community';
                  return null;
                }}
              />
              <Route path="*" component={NotFound} />
            </Switch>
          ) : (
            <Switch>
              <Route path="/" exact>
                <Redirect to={`/vendoraccess/${useResponsivePageName}monitoring`} />
              </Route>
              <Route path={`${this.state.match.url}`} exact>
                <Redirect to={`/vendoraccess/${useResponsivePageName}monitoring`} />
              </Route>
              <Route path="/vendoraccess" exact>
                <Redirect to={`/vendoraccess/${useResponsivePageName}monitoring`} />
              </Route>

              {isMobile && (
                <Route path={`/vendoraccess/monitoring`} exact>
                  <Redirect to={`/vendoraccess/${useResponsivePageName}monitoring`} />
                </Route>
              )}
              {isMobile && (
                <Route path={`/vendoraccess/complaint`} exact>
                  <Redirect to={`/vendoraccess/${useResponsivePageName}complaint`} />
                </Route>
              )}

              <Route
                path={`/vendoraccess/${useResponsivePageName}monitoring`}
                exact
                component={WaitingComponent(
                  isMobile ? VendorAccessMonitoringResponsive : VendorAccessMonitoring
                )}
              />
              <Route
                path={isMobile ? `/vendoraccess/${useResponsivePageName}monitoring/detail/:venmonid` : `/vendoraccess/${useResponsivePageName}monitoring/detail`}
                exact
                component={WaitingComponent(
                  isMobile ? VendorAccessMonitoringDetailResponsive : VendorAccessMonitoringDetail
                )}
              />

              <Route
                path={`/vendoraccess/${useResponsivePageName}complaint`}
                exact
                component={WaitingComponent(
                  isMobile ? VendorAccessComplaintResponsive : VendorAccessComplaint
                )}
              />
              <Route
                path={`/vendoraccess/${useResponsivePageName}complaint/detail`}
                exact
                component={WaitingComponent(
                  isMobile ? VendorAccessComplaintDetailResponsive : VendorAccessComplaintDetail
                )}
              />

              <Route component={NotFound} />
            </Switch>
          )}
          <Footer />
        </div>
      </div>
    );
  }
}

export default withContext(AppRoutes);
